<h1 *ngIf="!doNotTranslateTitle" mat-dialog-title>{{ title| translate }}</h1>
<h1 *ngIf="doNotTranslateTitle" mat-dialog-title>{{ title }}</h1>
<p *ngIf="!doNotTranslateText"> {{ text| translate }}</p>
<p *ngIf="doNotTranslateText"> {{ text }}</p>
<div mat-dialog-actions class="buttons">
  <button *ngIf="!doNotTranslateButtonTitle" mat-raised-button matDialogClose="" color="primary" class="continue" class="single-button" > {{ buttonTitle | translate }}</button>
  <button *ngIf="doNotTranslateButtonTitle" mat-raised-button  matDialogClose="" color="primary" class="continue" class="single-button" > {{ buttonTitle | translate }}</button>
</div>